import { useState } from "react";
import { ZoomIn } from "lucide-react";
import Lightbox from "./Lightbox";

// Non-invasive zoom overlay. Place as a sibling inside any `relative`
// container that already holds the product image(s). This component adds:
//   1. An invisible full-container button (cursor-zoom-in) that opens a
//      fullscreen Lightbox on click.
//   2. A tiny ZOOM hint chip that fades in on hover.
//   3. The Lightbox modal itself.
//
// Because it's an overlay-only sibling, dropping this into a container
// leaves the underlying image layout completely untouched, pixel-identical
// on hover-less views. `enabled` renders nothing when false so category
// scoping stays a one-prop toggle at the call site.
export default function ZoomOverlay({
  enabled,
  images,
  index,
  onIndexChange,
  alt,
  hintClassName = "",
  hintTestId = "zoom-hint",
}) {
  const [open, setOpen] = useState(false);
  if (!enabled) return null;

  const controlledIndex = typeof index === "number" ? index : 0;
  const setIndex = onIndexChange || (() => {});

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="group absolute inset-0 z-20 cursor-zoom-in bg-transparent"
        aria-label="Zoom image"
        data-testid="zoom-overlay-trigger"
      >
        <span
          className={`pointer-events-none absolute right-3 top-3 z-10 flex items-center gap-1 rounded-full bg-white/90 px-2.5 py-1 font-mono text-[10px] tracking-[0.14em] text-ink opacity-0 shadow-sm backdrop-blur transition-opacity duration-200 group-hover:opacity-100 ${hintClassName}`}
          data-testid={hintTestId}
        >
          <ZoomIn className="h-3 w-3" />
          ZOOM
        </span>
      </button>
      <Lightbox
        open={open}
        onClose={() => setOpen(false)}
        images={images}
        index={controlledIndex}
        onIndexChange={setIndex}
        alt={alt}
      />
    </>
  );
}
